"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapSearchResultsQueryToContentItems = void 0;
var _mapSearchResultsPageQueryToProductListingRows = require("./mapSearchResultsPageQueryToProductListingRows");
/* istanbul ignore file */ const mapSearchResultsQueryToContentItems = (query)=>{
    const rows = (0, _mapSearchResultsPageQueryToProductListingRows.mapSearchResultsPageQueryToProductListingRows)(query);
    return rows ? [
        {
            __typename: 'EditorialPlpRows',
            content: {
                ...rows
            }
        }
    ] : [];
};
exports.mapSearchResultsQueryToContentItems = mapSearchResultsQueryToContentItems;
